// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__20EHs","tab":"ProcedureTabs_tab__3apVF"};